import { Icons as e } from "../Icons/Icons.mjs";
import { Button as t } from "../Button/Button.mjs";
import { useMobile as n } from "../../hooks/useMobile.mjs";
import { MobileFullscreen as r } from "../Popup/Popup.mjs";
import { PanelCard as i, PanelContainer as a, PanelContent as o, PanelEmptyState as s, PanelFooter as c, PanelHeader as l, PanelHeaderInfo as u, PanelSuggestionChip as d, PanelSuggestionsRow as f } from "./FloatingPanel.styled.mjs";
import p from "react";
import { useTranslation as m } from "@maat/store-i18n";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
import { createPortal as _ } from "react-dom";
//#region src/components/FloatingPanel/FloatingPanel.tsx
var v = ({ title: n, icon: r, onClose: i, actions: a, className: o }) => {
	let { t: s } = m("ds");
	return /* @__PURE__ */ g(l, {
		className: o,
		children: [/* @__PURE__ */ g(u, { children: [r, typeof n == "string" ? /* @__PURE__ */ h("span", { children: n }) : n] }), /* @__PURE__ */ g("div", {
			style: {
				display: "flex",
				alignItems: "center",
				gap: 4
			},
			children: [a, /* @__PURE__ */ h(t, {
				variant: "ghost",
				size: "icon",
				onClick: i,
				"aria-label": s("ds:floatingPanel.close"),
				children: /* @__PURE__ */ h(e.X, { size: 18 })
			})]
		})]
	});
}, y = p.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ h(o, {
	ref: n,
	...t,
	children: e
}));
y.displayName = "FloatingPanel.Content";
var b = ({ children: e, ...t }) => /* @__PURE__ */ h(c, {
	...t,
	children: e
}), x = ({ children: e, ...t }) => /* @__PURE__ */ h(s, {
	...t,
	children: e
}), S = ({ children: e, ...t }) => /* @__PURE__ */ h(f, {
	...t,
	children: e
}), C = ({ children: e, ...t }) => /* @__PURE__ */ h(d, {
	...t,
	children: e
}), w = ({ open: e, ai: t, portal: o = !0, onClose: s, children: c, className: l, ...u }) => {
	let { isMobile: d } = n();
	if (!e) return null;
	let f = /* @__PURE__ */ h(a, {
		className: l,
		...u,
		children: /* @__PURE__ */ h(i, {
			ai: t,
			padding: "none",
			elevation: "high",
			children: c
		})
	});
	return /* @__PURE__ */ h(r, {
		open: e,
		onClose: s,
		children: o && !d && typeof document < "u" ? _(f, document.body) : f
	});
};
w.Header = v, w.Content = y, w.Footer = b, w.EmptyState = x, w.SuggestionsRow = S, w.SuggestionChip = C;
//#endregion
export { w as FloatingPanel };
